var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-100 h-100 flex-box bg-secondary" }, [
    _c(
      "a",
      {
        staticClass: "block__absolute block__absolute--auto",
        on: {
          click: function ($event) {
            return _vm.$emit("backClickedFromRegister")
          },
        },
      },
      [
        _c("img", {
          staticClass: "icon icon-xs",
          attrs: {
            src: require("@/assets/img/icons/svgs/solid/arrowLeft.svg"),
          },
        }),
      ]
    ),
    _c("div", { staticClass: "card bg_disabled" }, [
      _c(
        "div",
        {
          staticClass:
            "card-header bg-transparent border-0 align-items-stretch w-100",
        },
        [_c("div", { staticClass: "logo-head mx-auto" }, [_c("logo")], 1)]
      ),
      _c("div", { staticClass: "card-body" }, [
        _vm._m(0),
        _c(
          "form",
          { attrs: { role: "form" } },
          [
            _c("base-input", {
              staticClass: "mb-3",
              attrs: {
                alternative: "",
                "prepend-icon": "ni ni-single-02",
                placeholder: "First Name",
              },
              model: {
                value: _vm.firstname,
                callback: function ($$v) {
                  _vm.firstname = $$v
                },
                expression: "firstname",
              },
            }),
            _vm.$v.firstname.$error
              ? _c("div", { staticClass: "error field" }, [
                  _vm._v("First Name is required"),
                ])
              : _vm._e(),
            _c("base-input", {
              staticClass: "mb-3",
              attrs: {
                alternative: "",
                "prepend-icon": "ni ni-single-02",
                placeholder: "Last Name",
              },
              model: {
                value: _vm.lastname,
                callback: function ($$v) {
                  _vm.lastname = $$v
                },
                expression: "lastname",
              },
            }),
            _vm.$v.lastname.$error
              ? _c("div", { staticClass: "error field" }, [
                  _vm._v("Last Name is required"),
                ])
              : _vm._e(),
            _c("base-input", {
              staticClass: "mb-3",
              attrs: {
                alternative: "",
                "prepend-icon": "ni ni-email-83",
                placeholder: "Email",
              },
              model: {
                value: _vm.email,
                callback: function ($$v) {
                  _vm.email = $$v
                },
                expression: "email",
              },
            }),
            _vm.$v.email.$error
              ? _c("div", { staticClass: "error field" }, [
                  _vm._v("Valid email is required"),
                ])
              : _vm._e(),
            _vm.serverError.email
              ? _c("div", { staticClass: "error field" }, [
                  _vm._v(_vm._s(_vm.serverError.email)),
                ])
              : _vm._e(),
            _c("base-input", {
              staticClass: "mb-3",
              attrs: {
                alternative: "",
                "prepend-icon": "ni ni-lock-circle-open",
                type: "password",
                placeholder: "Password",
              },
              model: {
                value: _vm.password,
                callback: function ($$v) {
                  _vm.password = $$v
                },
                expression: "password",
              },
            }),
            _vm.$v.password.$error
              ? _c("div", { staticClass: "error field" }, [
                  _vm._v(
                    "Passwords should be a minimum of 8 Characters, with at least one uppercase, one lowercase and one number or special character."
                  ),
                ])
              : _vm._e(),
            _c("base-input", {
              staticClass: "mb-3",
              attrs: {
                alternative: "",
                "prepend-icon": "ni ni-lock-circle-open",
                type: "password",
                placeholder: "Confirm Password",
              },
              model: {
                value: _vm.confirm,
                callback: function ($$v) {
                  _vm.confirm = $$v
                },
                expression: "confirm",
              },
            }),
            _vm.$v.confirm.$required == false
              ? _c("div", { staticClass: "error field" }, [
                  _vm._v("Confirm password is required."),
                ])
              : _vm._e(),
            _vm.$v.confirm.sameAsPassword == false
              ? _c("div", { staticClass: "error field" }, [
                  _vm._v("Confirm should match with password."),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c(
                  "base-button",
                  {
                    staticClass: "my-4 btn-block",
                    attrs: { type: "primary" },
                    on: { click: _vm.handleRegistration },
                  },
                  [_vm._v("Register")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("p", [_c("b", [_vm._v("Please fill up the form below:")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }